import { render } from "./stepContainer.vue?vue&type=template&id=36f6c281&scoped=true"
import script from "./stepContainer.vue?vue&type=script&lang=js"
export * from "./stepContainer.vue?vue&type=script&lang=js"

import "./stepContainer.vue?vue&type=style&index=0&id=36f6c281&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36f6c281"]])

export default __exports__